import React from "react";
import {
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import { ReactComponent as UnCheckedIcon } from "../assets/images/uncheck-icon.svg";
import { ReactComponent as CheckedIcon } from "../assets/images/checked-icon.svg";

const CRadioGroup = ({
  options = [],
  name,
  label,
  value,
  onChange,
  row = false,
  className,
}) => {
  return (
    <FormControl className={className}>
      {label && (
        <FormLabel className="text-sm leadin-sm text-blue-500">
          {label}
        </FormLabel>
      )}
      <RadioGroup name={name} value={value} onChange={onChange} row={row}>
        {options.map((option) => (
          <FormControlLabel
            key={option.value}
            value={option.value}
            control={
              <Radio icon={<UnCheckedIcon />} checkedIcon={<CheckedIcon />} />
            }
            label={option.label}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};

export default CRadioGroup;
